import { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function Cookies() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div data-testid="cookies-page" className="pt-20">
      <section className="pt-[35px] pb-[35px] md:py-16 bg-[#FBFBF7] border-b border-border">
        <div className="mx-auto w-full max-w-[var(--container-max)] px-4 sm:px-6 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-6">
              &larr; Back to Home
            </Link>
            <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Advertising & Cookies</h1>
          </motion.div>
        </div>
      </section>

      <section className="pt-[35px] pb-[35px] md:py-16">
        <div className="mx-auto w-full max-w-3xl px-4 sm:px-6">
          <div className="prose prose-sm max-w-none space-y-8">
            <div>
              <h2 className="text-xl font-bold mb-3">1. What Are Cookies</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Cookies are small text files placed on your device when you visit our website. They help us provide a better browsing experience by remembering your preferences and understanding how you use our site.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">2. Types of Cookies We Use</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-base font-semibold mb-1">Essential Cookies</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    Required for the website to function properly. These cannot be disabled and include session management and security cookies.
                  </p>
                </div>
                <div>
                  <h3 className="text-base font-semibold mb-1">Analytics Cookies</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    Help us understand how visitors interact with our website. We use this data to improve the site experience. These cookies collect anonymous statistical data.
                  </p>
                </div>
                <div>
                  <h3 className="text-base font-semibold mb-1">Functional Cookies</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    Remember your preferences and settings (such as language or region) to provide a more personalized experience.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">3. Advertising</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Maple Code Academy may use online advertising services to reach parents interested in coding education for their children. These services may use cookies to deliver relevant advertisements based on your browsing activity. We do not sell personal information to advertisers.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">4. Third-Party Services</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Our website may include links to third-party services or embedded content (such as social media widgets). These third parties may set their own cookies. We encourage you to review their privacy policies.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">5. Managing Cookies</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                You can control and manage cookies through your browser settings. Most browsers allow you to refuse or delete cookies. Please note that disabling certain cookies may affect the functionality of our website.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">6. Updates to This Policy</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                We may update this Advertising & Cookies policy from time to time. Changes will be posted on this page with an updated revision date.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold mb-3">7. Contact Us</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                For questions about cookies and advertising on our site, please contact us at info@maplecodeacademy.ca.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
